import colors from './colors'
import fonts from './fonts'

export default {
  colors,
  fonts,

  border: `1px solid ${colors.slate}`,
}
